import { gate } from 'hub-http/gates';
export const CHANNEL_MANAGER_EXP_CALLING_TRIALS = gate('ChannelManagerExp:CallingTrials');
export const CHANNEL_MANAGER_EXP_INTERNATIONAL_PHASE_3 = gate('Channel:Manager:InternationalPhase3');
export const CHANNEL_MANAGER_EXP_INTERNATIONAL_PORTING = gate('Channel:Manager:InternationalPorting');